import { z } from 'zod'

import { learningItemParser } from '../../models/LearningItem'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'
import { ReturnsLearningItems, ReturnsUserLearningAssignments, ReturnsUsers } from '../useInvalidate'

export default function useUserLearningItems(uuid: string | null | undefined) {
  const { data, ...result } = useApiQuery({
    queryKey: ['userLearningItems', ReturnsUsers, ReturnsUserLearningAssignments, ReturnsLearningItems, uuid],
    placeholderData: (previousData) => previousData || [],
    queryFn: async () => {
      if (!uuid) {
        return null
      }
      const res = await api.get(`user/${encodeURIComponent(uuid)}/learning-items`)

      return z.array(learningItemParser).parse(res)
    },
  })

  return { userLearningItems: data || [], ...result }
}
